import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d40c0c3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40c0c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d40c0c3')) {
      api.createRecord('3d40c0c3', component.options)
    } else {
      api.reload('3d40c0c3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d40c0c3&scoped=true&", function () {
      api.rerender('3d40c0c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admin/index.vue"
export default component.exports